'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024other from "./mealorama.-Meal-Course$other.js";
import * as $j_mealorama$002e$002dRecipe from "./mealorama.-Recipe.js";
var $p;
/** @constructor */
function $c_Lmealorama_Recipe$() {
}
export { $c_Lmealorama_Recipe$ as $c_Lmealorama_Recipe$ };
$p = $c_Lmealorama_Recipe$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Recipe$;
/** @constructor */
function $h_Lmealorama_Recipe$() {
}
export { $h_Lmealorama_Recipe$ as $h_Lmealorama_Recipe$ };
$h_Lmealorama_Recipe$.prototype = $p;
$p.m = (function() {
  return "Recipe";
});
$p.a1Q = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().av(new $j_mealorama$002e$002dMeal$002dCourse$0024other.$c_Lmealorama_MealCourse$other("other"));
});
$p.aSp = (function(x$0) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(1));
  return new $j_mealorama$002e$002dRecipe.$c_Lmealorama_Recipe($x_2.l, $x_2.h, $x_1.l, $x_1.h, x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), x$0.g(6), x$0.g(7), x$0.g(8), x$0.g(9), x$0.g(10), x$0.g(11), x$0.g(12), x$0.g(13), x$0.g(14), x$0.g(15), x$0.g(16), x$0.g(17), x$0.g(18), x$0.g(19), x$0.g(20), x$0.g(21), x$0.g(22), x$0.g(23), x$0.g(24));
});
var $d_Lmealorama_Recipe$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Recipe$, "mealorama.Recipe$", ({
  GK: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Recipe$ as $d_Lmealorama_Recipe$ };
var $n_Lmealorama_Recipe$;
function $m_Lmealorama_Recipe$() {
  if ((!$n_Lmealorama_Recipe$)) {
    $n_Lmealorama_Recipe$ = new $c_Lmealorama_Recipe$();
  }
  return $n_Lmealorama_Recipe$;
}
export { $m_Lmealorama_Recipe$ as $m_Lmealorama_Recipe$ };
//# sourceMappingURL=mealorama.-Recipe$.js.map
